<template>
  <Action
    v-if="isAuthenticated"
    @click="toggleActive()"
    ofType="large"
    :content="isActive ? 'Active' : 'Add'"
    :isLoading="isLoading"
    :disabled="isLoading"
    v-tooltip="{
      content:
        !isLoading && !isActive
          ? 'Add To Active Courses'
          : 'Remove From Active Courses',
      placement: 'bottom-center',
    }"
  >
    <template v-slot:icon>
      <ActiveCoursesIcon class="action__large--icon active__icon" />
    </template>
  </Action>
</template>

<script>
import { mapState } from 'vuex'
import Action from '@/components/shared/Action.vue'
import ActiveCoursesIcon from '@/assets/icons/navigation/active_courses.svg'

export default {
  name: 'Active',
  data() {
    return {
      isLoading: false,
    }
  },
  props: {
    course: {
      type: Object,
      required: true,
    },
  },
  components: {
    Action,
    ActiveCoursesIcon: { ...ActiveCoursesIcon, name: 'ActiveCoursesIcon' },
  },
  computed: {
    ...mapState({
      active: state => state.courses.activeCourses,
      isAuthenticated: state => state.auth.isAuthenticated,
    }),
    isActive() {
      if (this.active && this.active.length) {
        return this.active.find(
          activeCourse => activeCourse.id === this.courseId
        )
      }
      return null
    },
    courseId() {
      return this.course.id || this.course.objectID
    },
  },
  methods: {
    async toggleActive() {
      this.isLoading = true
      if (!this.isActive) {
        await this.$store.dispatch('courses/addActiveCourse', this.courseId)
        this.sendMixpanelEvent(
          this.eventsConstants.CONTENT_COURSE_ACTIVE_ADDED,
          {
            course_id: this.courseId,
            course_name: this.course.name,
            trigger: 'courseButton',
            ...this.course,
          }
        )
      } else {
        await this.$store.dispatch('courses/removeActiveCourse', this.courseId)
        this.sendMixpanelEvent(
          this.eventsConstants.CONTENT_COURSE_ACTIVE_REMOVED,
          {
            course_id: this.courseId,
            course_name: this.course.name,
            trigger: 'courseButton',
            ...this.course,
          }
        )
      }
      await this.$store.dispatch('courses/getActiveCourses')
      this.isLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.active {
  &__icon {
    height: rem(24px);
    width: rem(24px);
    margin: 0 15px 0 0;
  }
}
</style>
